"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCheckbox = exports.Label = exports.HiddenCheckbox = exports.Flex = exports.CheckedIcon = exports.CheckboxContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

const CheckboxContainer = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  align-items: center;\n  ", ";\n"])), _ref => {
  var _theme$components, _theme$components$che;

  let {
    theme
  } = _ref;
  return theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : (_theme$components$che = _theme$components.checkbox) === null || _theme$components$che === void 0 ? void 0 : _theme$components$che.checkbox;
});

exports.CheckboxContainer = CheckboxContainer;

const Flex = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  ", ";\n"])), _ref2 => {
  var _theme$components2, _theme$components2$ch;

  let {
    theme
  } = _ref2;
  return theme === null || theme === void 0 ? void 0 : (_theme$components2 = theme.components) === null || _theme$components2 === void 0 ? void 0 : (_theme$components2$ch = _theme$components2.checkbox) === null || _theme$components2$ch === void 0 ? void 0 : _theme$components2$ch.flex;
});

exports.Flex = Flex;

const CheckedIcon = _styledComponents.default.svg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  fill: none;\n  stroke: ", ";\n  stroke-width: 3px;\n  ", ";\n"])), _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.color.font.primary;
}, _ref4 => {
  var _theme$components3, _theme$components3$ch;

  let {
    theme
  } = _ref4;
  return theme === null || theme === void 0 ? void 0 : (_theme$components3 = theme.components) === null || _theme$components3 === void 0 ? void 0 : (_theme$components3$ch = _theme$components3.checkbox) === null || _theme$components3$ch === void 0 ? void 0 : _theme$components3$ch.checkedicon;
}); // Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually


exports.CheckedIcon = CheckedIcon;

const HiddenCheckbox = _styledComponents.default.input.attrs({
  type: 'checkbox'
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  /* clippath: inset(50%); */\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"])));

exports.HiddenCheckbox = HiddenCheckbox;

const Label = _styledComponents.default.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-left: 5px;\n  color: ", ";\n  font-size: ", ";\n  cursor: pointer;\n  ", ";\n"])), _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.color.font.primary;
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.font.size.sm;
}, _ref7 => {
  var _theme$components4, _theme$components4$ch;

  let {
    theme
  } = _ref7;
  return theme === null || theme === void 0 ? void 0 : (_theme$components4 = theme.components) === null || _theme$components4 === void 0 ? void 0 : (_theme$components4$ch = _theme$components4.checkbox) === null || _theme$components4$ch === void 0 ? void 0 : _theme$components4$ch.label;
});

exports.Label = Label;

const StyledCheckbox = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 20px;\n  height: 20px;\n  border: thin solid ", ";\n  border-radius: ", ";\n  transition: all 150ms;\n  cursor: pointer;\n  ", "\n\n  ", " {\n    visibility: ", ";\n  }\n  ", ";\n"])), _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.color.border.primary;
}, _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.border.radius;
}, _ref10 => {
  let {
    round
  } = _ref10;
  return round && "\n    border-radius: 20px;\n  ";
}, CheckedIcon, _ref11 => {
  let {
    checked
  } = _ref11;
  return checked ? 'visible' : 'hidden';
}, _ref12 => {
  var _theme$components5, _theme$components5$ch;

  let {
    theme
  } = _ref12;
  return theme === null || theme === void 0 ? void 0 : (_theme$components5 = theme.components) === null || _theme$components5 === void 0 ? void 0 : (_theme$components5$ch = _theme$components5.checkbox) === null || _theme$components5$ch === void 0 ? void 0 : _theme$components5$ch.styledcheckbox;
});

exports.StyledCheckbox = StyledCheckbox;